var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34234 0.327252C9.29539 -0.109084 10.3921 -0.109084 11.3452 0.327252C14.7427 1.88274 17.2739 4.10793 18.4927 5.30825C19.1499 5.95544 19.5011 6.81846 19.5504 7.70859C19.6111 8.80549 19.6875 10.5841 19.6875 12.5905C19.6875 14.0064 19.6494 15.3085 19.6058 16.3374C19.5357 17.9862 18.2191 19.2796 16.575 19.336C15.0537 19.3882 12.7922 19.4406 9.84375 19.4406C6.89531 19.4406 4.63383 19.3882 3.11251 19.336C1.4684 19.2796 0.15176 17.9862 0.0817381 16.3374C0.038045 15.3085 0 14.0064 0 12.5905C0 10.5841 0.0764006 8.80549 0.137108 7.70859C0.186371 6.81846 0.537543 5.95544 1.19478 5.30825C2.41366 4.10793 4.94484 1.88274 8.34234 0.327252ZM6.34375 14.8468C5.86049 14.8468 5.46875 15.2385 5.46875 15.7218C5.46875 16.2051 5.86049 16.5968 6.34375 16.5968H13.3438C13.827 16.5968 14.2188 16.2051 14.2188 15.7218C14.2188 15.2385 13.827 14.8468 13.3438 14.8468H6.34375Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoof);
export default __webpack_public_path__ + "static/media/roof.c61b9e4e46c8514936f3c1c2a8344fec.svg";
export { ForwardRef as ReactComponent };